import React from 'react'
import cn from 'classnames'
import { forwardRef } from '~/ui/component'
import { createUseStyles, layout } from '~/ui/styling'
import { ResponsiveProp } from '~/ui/styling/layout'
import { FlexProp, flexStyle, useGapStyles, usePaddingStyles } from './styles'

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  padding?:           number | ResponsiveProp<number>
  paddingHorizontal?: number | ResponsiveProp<number>
  paddingVertical?:   number | ResponsiveProp<number>

  gap?: number | ResponsiveProp<number>

  align?:   'stretch' | 'left' | 'center' | 'right'
  justify?: 'top' | 'middle'| 'bottom' | 'space-between' | 'space-around'

  flex?:  FlexProp
  width?: React.CSSProperties['width']
  wrap?:  boolean

  tag?: string
}

const VBox = forwardRef('VBox', (props: Props, ref: React.Ref<HTMLDivElement>) => {

  const {
    align,
    justify,
    gap,
    padding,
    paddingHorizontal,
    paddingVertical,
    flex,
    width,
    wrap = false,
    classNames,
    tag = 'div',
    ...rest
  } = props

  const $        = useStyles(props)
  const gap$     = useGapStyles('column', gap, false)
  const padding$ = usePaddingStyles(padding, paddingHorizontal, paddingVertical)

  const className = cn([
    $.VBox,
    $[align ?? 'stretch'],
    $[justify ?? 'top'],
    gap$?.gap,
    padding$.padding,
    {wrap},
    classNames,
    props.className,
  ])

  const style = {
    ...flexStyle(flex),
    width,
    ...props.style,
  }

  return React.createElement(tag, {
    ...rest,
    className,
    style,
    ref,
  }, props.children)

})

export default VBox

const useStyles = createUseStyles({
  VBox: {
    ...layout.flex.column,

    '&.wrap': {
      flexWrap: 'wrap',
    },
  },

  stretch: {
    alignItems: 'stretch',
  },

  left: {
    alignItems: 'flex-start',
  },

  center: {
    alignItems: 'center',
  },

  right: {
    alignItems: 'flex-end',
  },

  top: {
    justifyContent: 'flex-start',
  },

  middle: {
    justifyContent: 'center',
  },

  bottom: {
    justifyContent: 'flex-end',
  },

  'space-between': {
    justifyContent: 'space-between',
  },

  'space-around': {
    justifyContent: 'space-around',
  },
})